import { STATUS_LABEL, type ArticleStatus } from "@features/articles/types";

export function StatusBadge({ status }: { status: ArticleStatus }) {
  return <span className={`badge badge-${status}`}>{STATUS_LABEL[status]}</span>;
}
